import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CustomSitesService } from '@app/modules/direct/services/custom-sites.service';
import { DirectAddService } from '@app/modules/direct/services/direct-add.service';

@Component({
  selector: 'sbnb-direct-add-select-type',
  templateUrl: './direct-add-select-type.component.html',
})
export class DirectAddSelectTypeComponent {
  creatingCustomSite = false;

  constructor(
    private readonly customSitesService: CustomSitesService,
    private readonly router: Router,
    public readonly directAddService: DirectAddService
  ) {}

  createCustomSite() {
    this.creatingCustomSite = true;

    this.customSitesService.addCustomSite().subscribe(
      (res) => this.router.navigate(['/direct/custom-sites', res.uuid]),
      () => (this.creatingCustomSite = false)
    );
  }
}
